export const EMPRESA = '100';

export const TabIds = {
  ENTER_BENEFIT: 'enter_benefit',
  ELEGIBILITY: 'eligibility',
  BENEFITS: 'benefits',
  REPORTS: 'reports',
};

export const tabTitles = {
  [TabIds.ENTER_BENEFIT]: 'Ingreso de prestaciones',
  [TabIds.ELEGIBILITY]: 'Consultar cobertura de prestación',
  [TabIds.BENEFITS]: 'Búsqueda de Tickets',
  [TabIds.REPORTS]: 'Reportes',
};

export const TICKET_TYPES = {
  BENEFIT: 'Prestación',
  DIAGNOSIS: 'Diagnóstico',
  ELIGIBILITY: 'Elegibilidad',
};
